import { WEEK_DAYS } from 'modules/arena/onboarding/content';
import { Input } from 'shared/components/ui/Input';
import { cn } from 'shared/utils/cn';
import { ArenaOnboardingState } from 'modules/arena/onboarding/useArenaOnboarding';

export function StepSchedule(state: ArenaOnboardingState) {
  return (
    <div className="flex flex-col gap-4">
      <p className="text-sm text-ink-secondary">Dias e horário de funcionamento da unidade.</p>

      <div className="flex flex-wrap gap-2">
        {WEEK_DAYS.map((day) => {
          const isSelected = state.openDays.includes(day);

          return (
            <button
              key={day}
              type="button"
              onClick={() => state.toggleDay(day)}
              className={cn(
                'h-10 w-12 rounded-lg border text-sm font-medium transition-colors',
                isSelected
                  ? 'border-primary bg-primary text-surface'
                  : 'border-border text-ink-secondary hover:border-primary'
              )}
            >
              {day}
            </button>
          );
        })}
      </div>

      <div className="flex gap-3">
        <Input
          label="Abre às"
          name="openTime"
          type="time"
          value={state.openTime}
          onChange={(event) => state.setOpenTime(event.target.value)}
        />
        <Input
          label="Fecha às"
          name="closeTime"
          type="time"
          value={state.closeTime}
          onChange={(event) => state.setCloseTime(event.target.value)}
        />
      </div>
    </div>
  );
}
